import ProvidentFundNewsView from '../components/ProvidentFundNewsView';
export default function ProvidentFundBusiness(){return <ProvidentFundNewsView mode="business"/>;}
